import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-300/60 text-sm font-medium text-accent-700 bg-accent-50/80">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            Nos Catégories
          </span>
          <h2 className="mt-5 text-3xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight">
            Explorez Toutes les
            <br />
            Catégories de Produits
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            Cliquez sur une catégorie pour accéder au catalogue complet sur Kaspreadsheet.
          </p>
        </div>

        {/* Category Grid with Images - 3 columns on large screens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="category-card group flex items-center gap-5 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/70 transition-all duration-300 cursor-pointer"
            >
              {/* Category Image */}
              <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Hipobuy Spreadsheet`}
                  title={`${cat.name} - Catalogue Hipobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-400"
                  loading="lazy"
                />
              </div>

              {/* Category Info */}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </h4>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                  {cat.description}
                </p>
                <span className="category-arrow inline-flex items-center gap-1 mt-2 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Voir
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}